import axios from "axios";

// export const URL = "http://localhost:5000/";
export const URL = "https://api-virtual-patient.pointreg.ru/";  // yandex cloud
// export const URL = "https://patient.pep-server.ru/";

const instance = axios.create({
  baseURL: URL,
});

export const getCase = (id) => {
  return instance.get(`case/${id}`).then(response => response)
}
export const getUtils = (application_number) => {
  return instance.get(`utils/${application_number}`).then(response => response.data)
}
export const createSession = (id, application_number, ip) => {
  return instance.get(`api/create-session/${id}?application_number=${application_number}&ip=${ip}`).then(response => response)
}
export const updateSession = (variants, id, key, application_number = 1, date = new Date().toLocaleTimeString()) => {
  return instance.post('api/update-session', { variants, id, key, application_number, date }).then(response => response)
}
export const updateEndTime = (id, application_number = 1) => {
  return instance.get(`api/end-session?id=${id}&application_number=${application_number}`).then(response => response)
}
export const setCommentary = (commentary, id, key, application_number = 1) => {
  return instance.post('api/commentary-session', { commentary, id, key, application_number }).then(response => response)
}
export const selectAllSessions = (application_number) => {
  return instance.get(`api/select-sessions/${application_number}`).then(response => response.data)
}

